import { render, staticRenderFns } from "./PhoneField.vue?vue&type=template&id=bf0fc3c6&"
import script from "./PhoneField.vue?vue&type=script&lang=js&"
export * from "./PhoneField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Abdelaziz\\Documents\\depot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf0fc3c6')) {
      api.createRecord('bf0fc3c6', component.options)
    } else {
      api.reload('bf0fc3c6', component.options)
    }
    module.hot.accept("./PhoneField.vue?vue&type=template&id=bf0fc3c6&", function () {
      api.rerender('bf0fc3c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/custom-fields/PhoneField.vue"
export default component.exports